import React, { useState } from "react";
import styled from "@emotion/styled";
import { connectLocation } from "../../location/LocationConnectors"
import { DefaultTextInput } from "../../forms/OCInputs";

/**
Used in 
- app/javascript/components/PageBuilder/locator/tool/ContentHeader.jsx
- app/javascript/components/SDS/ContentHeader.jsx
*/

const MaxWidth = styled.div`
  width: 100%;
`

const Heading = styled.div`
  .title1 {
    font-size: 18px;
    margin:0;
  }
`

const ButtonSet = styled.div`
  display: flex;
  width: 100%;
  justify-content: right;
  margin-top: 20px;
  button, a {
    min-width: 97px;
    height: 36px;
    margin-bottom: 64px;
    margin-left: 20px;
  }
`;

const SearchInput = styled(DefaultTextInput)`
  padding: 16px 8px;
  border: 1px solid #585858;
  width: 100%;
  margin-top: 16px;
  font-size: revert;
`;

const EnterMessage = styled.p`
  font-size: 12px;
  text-align: right;
`

const SearchForm = ({ t, handleSearch, urlParams, fieldName, fieldPlaceholder, initialSearchValue }) => {
  const [searchValue, setSearchValue] = useState(initialSearchValue);

  const handleChange = (val) => {
    setSearchValue(val);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSearch(searchValue, urlParams);
  };

  return (<>
    <form onSubmit={handleSubmit} data-track="search-bar" data-track-search-term={searchValue}>
      <SearchInput
        id="header-search-input"
        name={fieldName}
        placeholder={fieldPlaceholder}
        onChange={(val) => handleChange(val)}
        value={searchValue} />
    </form>
    <EnterMessage>
      {t(`search_instruction`)}
    </EnterMessage>
  </>);
};

const SearchContentHeader = connectLocation(props => {
  const { t, title, loading, count, searchValue, buttons } = props
  const h1 = searchValue
    ? loading
      ? t(`results_heading.searching_with_text`, { search_text: searchValue })
      : t(`results_heading.searched_with_text`, { count: count, search_text: searchValue })
    : loading
      ? t(`results_heading.searching_without_text`)
      : t(`results_heading.searched_without_text`, { count: count })

  return (
    <>
      <Heading>
        <p className="title1">
          {title}
        </p>
        <h1 className='tier3'>
          {h1}
        </h1>
      </Heading>
      <MaxWidth data-am-region={title}>
        <SearchForm {...props} initialSearchValue={searchValue} />
      </MaxWidth>
      <ButtonSet>
        {buttons && buttons.map((button, i) => <React.Fragment key={i}>{button}</React.Fragment>)}
      </ButtonSet>
    </>
  )
});

export default SearchContentHeader
